import React from "react"
import './styles.css';

export default function ContentPopup({children,mx,w='',max_size='sm:max-w-xs',min_width="min-w-[12rem]"}) {
    return <div style={{maxHeight:`${mx}`}} className={`content-popup-shadow ${min_width} content-popup overflow-y-auto ${w} bg-white ${max_size} border border-gray-200 rounded-md`}>
        <div className="">
        {children}
        </div>
    </div>
};